<div class="overLayDiv active"></div>
<div id="rightSideBar" *ngIf="showPanel">
    <div class="rightSidePanel d-flex flex-column">
        <header class="panel-header">
            <div class="viewDemo title-and-video">
                <h2>{{ "early_termination_charges" | translate: param }}</h2>
            </div>            
            <div class="panel-left-btn">
                <button type="button" class="btn eod-btn-outline-warning" (click)="logout()">
                    {{ "logout" | translate: param }}
                </button>
            </div>
        </header>
        <div class="eod-panel-body-with-footer">
        <div class="block mt-2">
            <h6 class="info-text">
                <i class="fas fa-exclamation-circle eod-text-danger"></i>
                <span>{{ "early_termination_charges_msg1" | translate: param }}</span>
            </h6>
            <h6 class="info-text">
                <i class="fas fa-exclamation-circle eod-text-danger"></i>
                <span>
                    {{ "early_termination_charges_msg2" | translate: param }}
                    <a href="javascript:void(0);" (click)="download(organisationSubscriptionInvoiceResponse[0].invoiceUrl)" class="download-link">
                        {{ "download" | translate: param }}
                    </a> {{ "early_termination_charges_msg3" | translate: param }}
                </span>
            </h6>
            <h6 class="info-text mb-0 pb-0 border-0 ">
                <i class="fas fa-exclamation-circle eod-text-danger"></i>
                <span>{{ "early_termination_charges_msg4" | translate: param }}</span>
            </h6>
        </div>
        </div>
        <footer class="mt-auto py-1 d-flex justify-content-center align-items-center gap-2 height-60px">
            <button type="button" class="btn eod-btn-outline-warning" (click)="ResubscribeEODApplication()">
                {{ "early_termination_charges_msg5" | translate: param }}
            </button>
            <button type="button" class="btn eod-btn-primary" (click)="download(organisationSubscriptionInvoiceResponse[0].invoiceUrl)">
                {{ "early_termination_charges_msg6" | translate: param }}
            </button>
        </footer>
    </div>
</div>